var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommodities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0_2_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2_2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_2",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_2",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB70lEQVR4nO2bPS8EURSGz4iPAlHySxA0EgWV6PgPiK8gkah3S0pK/oFESeGjQMEvoLEVISoimUdm9mxMZCns3GTunfMkk8zek5w9eXPes5ubHBHD+BOgE6gCNfyhpjV3SasAFfylmocAj5psRDwBGNWaa3kKMCaekNSapwAV/KWS1xCsZDrBBx615taHYJZGdikgQKzlRS6/JEUKiAmAdUBc70+zQOTSZylSQMwCmAXien+aBSKXPkuRAmIWwCwQO7MAcIF/nOcpwDn+cZabAA0amaWA2AzAsyEIdACnwEnyXkYBljJ+XSyVAEAP8JwR4AnoLpMAy5rqMpnWeXSBNwIA7cCDppoEpvT9PomVQYA5TXOrnyPgTs9myyDAsaZZypyt6NlR0AIAfcAH8An0Z84H9Owd6A1ZgAlNcdUkdqOx8ZAFWNUUe01i+z+tEaIA25pivUlsU2NbIQuwoSl2msR2NbYWsgDDmuIFmE4Gnj4zwJvGhoIVIAE45HcO5J/4JEAbsKBT/1Wfa2A+iQUvgCtMAKwDYmcWwG6FsVvhBBuCihQQG4LYr0CsDWp/hMShz1KkgJgFMAvE9f60GRC59FmKFBCzAGaB2IkF+N4a821hwrbGyHlrbFBKujRVa+W6OoS1uSolt0BnqVdnDQmbL+yBxe1/tBpQAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommodities);
export default __webpack_public_path__ + "static/media/commodities.27fc159d258ffe1ce45963ef34ad9c37.svg";
export { ForwardRef as ReactComponent };